import { TFunc } from '@Translations/types';

// Coverage bands, matching the redesign: Complete >= 70, Partial >= 35,
// otherwise Minimal. The single source for the grid cell and the Explanation panel.
export type CoverageBandKey = 'complete' | 'partial' | 'minimal';

export const COVERAGE_THRESHOLDS = { complete: 70, partial: 35 } as const;

export const coverageBandKey = (pct: number): CoverageBandKey => {
	if (pct >= COVERAGE_THRESHOLDS.complete) return 'complete';
	if (pct >= COVERAGE_THRESHOLDS.partial) return 'partial';
	return 'minimal';
};

export const coverageBand = (pct: number, t: TFunc) => {
	const key = coverageBandKey(pct);
	if (key === 'complete')
		return { key, label: t('Complete'), color: '#1E40AF' };
	if (key === 'partial')
		return { key, label: t('Partial'), color: '#2563EB' };
	return { key, label: t('Minimal'), color: '#9a5b25' };
};
